import { useTranslation } from "react-i18next";
import PageHeader from "../../../components/Common/PageHeader";
import TableFilterDynamique, { FilterField } from "components/Common/TableFilter/TableFilterDynamique";
import { all_routes } from "router/all_routes";
import { useEffect, useMemo, useState } from "react";
import { message } from "antd";
import usePayroll from "../hooks/usePayroll";
import CustomButton from "components/Common/ui/CustomButton";
import PayrollTable from "../components/PayrollTable";
import { getFirstAndLastDayOfMonth } from "utils/dateUtils";
import { useAbility } from "config/abilityContext";

const PayrollPage = () => {
    const { t } = useTranslation();
    const ability = useAbility();

    const {
        payrolls,
        loading,
        generating,
        fetchPayrolls,
        handleGeneratePayroll,
        handleUpdateStatus,
        pagination,
        statusOptions,
    } = usePayroll();

    const breadcrumbItems = [
        { label: "dashboard", path: all_routes.dashboard },
        { label: "payroll.title", active: true },
    ];

    const [filters, setFilters] = useState<{ [key: string]: string | number | null }>({});

    useEffect(() => {
        fetchPayrolls({ page: 1, limit: 10 });
    }, [fetchPayrolls]);

    const filterFields: FilterField[] = useMemo(
        () => [
            // { key: "search", label: t("search"), type: "text" },
            {
                key: "status",
                label: t("payroll.status"),
                type: "select",
                options: statusOptions
            }
        ],
        [t]
    );

    const handleFilter = (newFilters: { [key: string]: string | number | null }) => {
        setFilters(newFilters);
        fetchPayrolls({ ...newFilters, page: 1 });
    };

    const handleGenerateAll = async () => {
        const { startDate, endDate } = getFirstAndLastDayOfMonth();
        console.log(startDate, endDate);
        const payload = {
            startDate: startDate,
            endDate: endDate
        };

        await handleGeneratePayroll(payload);

    };

    return (
        <div className="page-wrapper">
            <div className="content container-fluid">
                <PageHeader title={t("payroll.title")} breadcrumbItems={breadcrumbItems} />

                <div className="d-flex mb-3 justify-content-end gap-2">
                    {ability.can("create", "Payroll") && (
                        <CustomButton
                            onClick={handleGenerateAll}
                            disabled={generating}
                        >
                            <i className="ti ti-coin me-2" />
                            {t("payroll.generate_for_all_staff")}
                        </CustomButton>
                    )}

                    <TableFilterDynamique
                        fields={filterFields}
                        filters={filters}
                        onApply={(newFilters) => handleFilter(newFilters)}
                        onReset={() => handleFilter({ page: 1, limit: 10 })}
                    />
                </div>

                <PayrollTable
                    dataSource={payrolls ?? []}
                    loading={loading}
                    onUpdateStatus={handleUpdateStatus}
                    dataPaginate={{
                        current: pagination?.page,
                        pageSize: pagination?.limit,
                        total: pagination?.total,
                    }}
                    onChange={(pg) => {
                        fetchPayrolls({
                            ...filters,
                            page: pg?.current!,
                            limit: pg?.pageSize!,
                        });
                    }}
                />
            </div>
        </div>
    );
};

export default PayrollPage;